import type { useForm } from "hooks";
import type { CustomFile } from "lib/upload";
import type { BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    AccountHolderName = 'accountHolderName',
    BankName = 'bankName',
    Iban = 'iban',
    Swift = 'swift',
    ProofFileKey = 'proofFileKey',
    Currency = 'currency',
    AvgTransactionSize = 'avgTransactionSize',
    MonthlyIncome = 'monthlyIncome',
    TransactionVolume = 'transactionVolume'
};

export type OnboardingBankingAndFinance = {
    readonly [FormField.AccountHolderName]: string;
    readonly [FormField.BankName]: string;
    readonly [FormField.Iban]: string;
    readonly [FormField.Swift]: string;
    readonly [FormField.ProofFileKey]: string | CustomFile | null;
    readonly [FormField.Currency]: string | null;
    readonly [FormField.AvgTransactionSize]: string;
    readonly [FormField.MonthlyIncome]: string;
    readonly [FormField.TransactionVolume]: string;
};

export type OnboardingBankingAndFinanceForm = Omit<
    BootstrapableForm<OnboardingBankingAndFinance, {}>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingBankingAndFinance;
};

export type OnboardingBankingAndFinanceProps =
    & OnboardingFormProps
    & OnboardingBankingAndFinanceForm
    & ReturnType<typeof useForm<OnboardingBankingAndFinance>>;
